import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const ReportSetup = lazy(() =>
  import("@scenes/ReportBuilder2/ReportSetup/ReportSetup").then((module) => ({
    default: module.ReportSetup,
  }))
);

export const reportBuilder2EditNRO: NavigationRoutingObject = {
  section: "analytics",
  Component: ReportSetup,
  componentFeatureFlippers: [],
  heading: (t: I18nT<"dashboard-navigation">) => t("report-builder-2-edit-nro-heading", "Edit Report"),
  tag: "beta",
  getDeveloperNavigationAllowed: ({ isImpersonating, hasPermission }) => {
    const userHasEditReportingPermission = hasPermission("appGroupOrAnyTeamInAppGroup", {
      permission: "editReporting",
    });
    return isImpersonating || userHasEditReportingPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/report_builder_2/:appGroupId",
  noKnockoutFallback: true,
};
